export default {
  subscribe: "S'abonner",
  subscribeText: "Restez informé des derniers cours et offres de SkillSynergy.",
  submit: "Envoyer",
  sending: "Envoi en cours...",
  success: "Abonné !",
  failed: "Échec !",
};
